// @flow
import React from 'react'
import gtmParts from 'react-google-tag-manager'

type GTMProps = {
  additionalEvents?: {
    [key: string]: any
  },
  dataLayerName?: string,
  id: string,
  previewVariables?: string,
  scriptId?: string,
}

type GTMState = {
  alreadyHasDataLayer: boolean,
}

export default class GoogleTagManager extends React.Component<GTMProps, GTMState> {
  static defaultProps = {
    additionalEvents: {}, // unused
    dataLayerName: 'dataLayer',
    previewVariables: '',
    scriptId: 'gtm-script',
  }

  constructor(props: GTMProps) {
    super(props)

    this.state = {
      alreadyHasDataLayer: typeof window.dataLayer !== 'undefined' || typeof dataLayer !== 'undefined'
    }
  }

  render = () => {
    if (this.state.alreadyHasDataLayer) {
      return null
    }

    const gtm = gtmParts({ ...this.props })
    let script = document.getElementById(this.props.scriptId)
    if (!script) {
      script = document.createElement('script')
      script.id = this.props.scriptId
      document.head.appendChild(script)
    }
    script.textContent = gtm.scriptAsReact().props.dangerouslySetInnerHTML.__html

    return gtm.noScriptAsReact()
  }
}
